
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import AOS from 'aos';

const GdprPolicy = () => {
  const routes = all_routes;

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="main-wrapper">
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Politica GDPR</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={routes.home}>Acasă</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">GDPR</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section className="section-modern" style={{ padding: '60px 0' }}>
         <div className="container">
          <div 
            className="policy-content" 
            style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
            data-aos="fade-up"
          >
             <h3 className="mb-4">Angajamentul Nostru față de GDPR</h3>
             <p className="mb-4">
               Regulamentul (UE) 2016/679 (GDPR) impune reguli stricte pentru protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal. AD SHOWROOM se aliniază acestor standarde.
             </p>

             <h3 className="mb-4">Principii de Prelucrare</h3>
             <ul className="list-group mb-4">
                 <li className="list-group-item"><strong>Legalitate, echitate și transparență:</strong> Datele sunt prelucrate legal și sunteți informat clar despre acest lucru.</li>
                 <li className="list-group-item"><strong>Limitarea scopului:</strong> Datele sunt colectate doar pentru scopuri determinate (ex: vânzare auto, facturare).</li>
                 <li className="list-group-item"><strong>Minimizarea datelor:</strong> Cerem doar datele strict necesare.</li>
                 <li className="list-group-item"><strong>Exactitate:</strong> Ne asigurăm că datele sunt corecte și actualizate.</li>
                 <li className="list-group-item"><strong>Integritate și confidențialitate:</strong> Folosim măsuri de securitate (criptare, acces restricționat) pentru a proteja datele.</li>
             </ul>

             <h3 className="mb-4">Responsabilul cu Protecția Datelor (DPO)</h3>
             <p>
               Pentru orice solicitare legată de datele personale, vă rugăm să contactați responsabilul nostru cu protecția datelor la: <a href="mailto:adcarshowroom@gmail.com">adcarshowroom@gmail.com</a>
             </p>
             <div className="alert alert-info">
                 <strong>Email DPO:</strong> adcarshowroom@gmail.com<br/>
                 <strong>Adresă poștală:</strong> [ADRESA COMPLETA SEDIU]
             </div>
             
             <p className="mt-3">
                 Pentru detalii complete despre drepturile dvs. și categoriile de date, vă rugăm să consultați <Link to={routes.privacypolicy}>Politica de Confidențialitate</Link>.
             </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GdprPolicy;
